module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_12_sp-7d3f7a90e90efa54a0e874c9cc45eda4.png";